import React, { FC, useEffect, useState, useMemo } from "react";
import { Modal, Input, Radio, notification, DatePicker, Button } from "antd";
import { filter, includes, isEmpty, map, cloneDeep, findIndex, set, find, get} from "lodash";
import classnames from "classnames";
import moment, { Moment } from "moment";

// adding local dependencies
import "./program.scss";
import Icon from "@assets/icon_config";
import CareCoordinationService from "@services/care-coordination";
import membersService from "@services/members.service";
import memberService from "@services/members.service";
import { useCareCoordinationStore } from "../../../../../stores/useCareCoordinationStore";
import {
  dateFormatConfig,
  CREATE_CARE_PRGM,
  USER_ACTION_CARD_PROGRAM,
  USER_ACTION_LOCATION_INTERVENTION_HEADER,
  USER_ACTION_DESCRIPTION_PROGRAM_ASSIGNMENT,
  CASE_STATUS_REASON_ASSIGNMENT,
} from "@utils/constants";
import { isAutoCaseStatus, getClientName, milleniumClientCheck } from "@utils/helpers";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import {
  CASE_STATUS_REASON_PROGRAM_CHANGE,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_CARE_MANAGEMENT,
  USER_ACTION_LOCATION_PROGRAM,
  USER_ACTION_DESCRIPTION_PROGRAM_SAVE,
  CASE_STATUS_CLOSED,
  CASE_STATUS_ACTIVE,
  USER_ACTION_DESCRIPTION_REGISTRY_UPDATE,
} from "@utils/constants";
import sessionService from "@services/session.service";
import { useProgram } from "../../customHooks";
import DataNotFound from "@components/noDataFound";
import { NO_PROGRAM_AVAILABLE } from "../../../../../constants/constants";
import { GenericModal } from "@components/modal-custom";
import { useProgramMetaData , useAdditionalData} from "../../customHooks";
import { Spinner } from "@components/healthemSpinner/healthemSpinner";
import { useReferralsStore } from "@stores/referralsStore";
// import { DateRange } from "@components/dateRange";

/******************************************************************************* */
const { RangePicker } = DatePicker;

interface ProgramProps {
  patientId: any;
  isModalVisible: boolean;
  setIsModalVisible: (x: any) => void;
  selectedValuesOfProgram: number | undefined;
  setSelectedValuesOfProgram: (x: any) => void;

  programEndDate: Moment | undefined;
  setProgramEndDate: (x: any) => void;
  initialLoad: (x: any) => void;
  loading: boolean;
  setLoading: (x: any) => void;
  programStartDate: string | undefined;
  setProgramLoading: (x: any) => void;
  actionData?: any;
}

let modifedProgramSize = 32;

const CustomDatePicker = ({value , format = dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormatWithTime"], onChange , key , label , disabledDate =  () => false , disabled= false} : any) => {
  return (
    <div className={`additional_details__item`}>
      <span className="additional_details__item__calender-icon">
        <Icon name="calender" />
      </span>
      <div className="additional_details__item__label">
        {label}<span style={{ color: "red" }}>*</span> :{" "}
      </div>
      <div className={`additional_details__item__value dateValue`}>
        <DatePicker
          showTime
          showNow={false}
          value={value}
          format={format}
          allowClear={false}
          onChange={(date) => onChange(date , key)}
          disabledDate={disabledDate}
          disabled = {disabled}
        />
      </div>
    </div>
  );
};

const Program: FC<ProgramProps> = ({
  patientId,
  isModalVisible,
  setIsModalVisible,
  selectedValuesOfProgram,
  setSelectedValuesOfProgram,
  programEndDate,
  setProgramEndDate,
  initialLoad,
  loading,
  setLoading,
  programStartDate,
  setProgramLoading,
  actionData = {}, //actionData is the meta data of create program and other callback functions called on cancel or update,
}) => {
  // local states

  const interventionStartDate = useCareCoordinationStore((state) => state.interventionStartDate);
  const setInterventionStartDate = useCareCoordinationStore((state) => state.setInterventionStartDate);
  const [setMemberPageLoader] = usePatientProfileStore((state) => [state.setMemberPageLoader]);
  const [registryDependentProgramsStatus, setRegistryDependentProgramsStatus] = usePatientProfileStore((state) => [state.registryDependentProgramsStatus, state.setRegistryDependentProgramsStatus]);
  const memberDetailListRegistryDropDown = useGlobalInformationStore((state) => state.memberDetailListRegistryDropDown);
  const memberDetailClassificationValues = useGlobalInformationStore((state) => state.memberDetailClassificationValues);
  const setMemberDetailClassificationValues = useGlobalInformationStore((state) => state.setMemberDetailClassificationValues);

  // const programOptions = useCareCoordinationStore((state) => state.programOptions);
  const assignedPrograms = useCareCoordinationStore((state) => state.assignedPrograms);
  const setAssignedPrograms = useCareCoordinationStore((state) => state.setAssignedPrograms);
  const [searchValue, setSearchValue] = useState<string>("");
  const [noDataFlag, setNoDataFlag] = useState<boolean>(false);
  const [modPrograms, setModPrograms] = useState<any[]>([]);
  const [registryDependentProgramModalVisibility, setRegistryDependentProgramModalVisibility] = useState<boolean>(false);
  const programsData = cloneDeep(useCareCoordinationStore((state: { dataForCareCoordination: any }) => state.dataForCareCoordination));
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const [additionalDetailsVisible , setAdditionalDetailsVisible] = useState<any>(false);
  const additionalData = useCareCoordinationStore((state) => state.additionalData);
  const setAdditionalData = useCareCoordinationStore((state) => state.setAdditionalData);
  const reerralStore = useReferralsStore((store) => store);

  const programName = useMemo(() => {
    const programSelected = assignedPrograms.find((program: any) => program.id === selectedValuesOfProgram);

    return programSelected?.name;
    
  }, [assignedPrograms, selectedValuesOfProgram]);

  const {programDescription, patientProgramId} = useProgram({programName});

  const {noAdditionalData} = useProgramMetaData({programName});

  const currentMember = membersService?.getCurrentMember;
  const getUserActionParams = (userActionDescription: any, reason: any, isCreateProgram = false) => {
    let actionCard = [
      programDescription,
      USER_ACTION_CARD_PROGRAM
    ]
    if (!isCreateProgram) {
      actionCard.splice(1, 0, patientProgramId)
    }
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
      actionCard: actionCard.join('$|'),
      actionLocation: USER_ACTION_LOCATION_INTERVENTION_HEADER,
      actionDescription: userActionDescription,
    };
    return props;
  };
  const disabledDate = (current: any) => {
    // Can not select days before today and today
    return current && current < moment().subtract(1, "days");
  };


  const {additionalDetails = [], disableInput , updateAdditionalDataInTask , isAdditionalValidationSuccess} = useAdditionalData({programName , patientId});


  useEffect(() => {
    console.log("Program.useEffect");
    const modifiedPrograms = assignedPrograms.filter((program: any) => program.status !== "Active");
    modifiedPrograms.length > 0 ? setNoDataFlag(false) : setNoDataFlag(true);
    if (modifiedPrograms.length > 1 && modifiedPrograms.length <= 4) {
      modifedProgramSize = (modifiedPrograms.length > 1 ? modifiedPrograms.length * 32 : 32) + 1;
    }
    setModPrograms(modifiedPrograms);
  }, [assignedPrograms, isModalVisible]);

  //   // function responsible to set the state of selected programs
  const handleSelectingProgram = (checkedValues: any) => {
    setSelectedValuesOfProgram(checkedValues);
  };

  const updateAssignedStatus = (programId: number | string, patientProgramId: number | string) => {
    console.log("Intervention.updateAssignedStatus");
    CareCoordinationService.updateAssignedStatus({ programId: programId, patientProgramId: patientProgramId, patientId: patientId, userId: sessionService?.getUser()?.id }).subscribe({
      next: (v) => {
        set(programsData, "assgnd_user_id", v.data.data.assignedTo);
        set(programsData, "userName", v.data.data.userName);
        setProgramsData(programsData);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  
  function createNewProgramServiceCall(selectedValuesOfProgram : any){
    setLoading(true);
    setProgramLoading(true);
    let startDateID: any = {
      'TCM': '-1',
      'ER': '-434'
    }

    let startDate = moment.utc(interventionStartDate)
    let endDate = moment.utc(programEndDate) 

    if (!noAdditionalData) {
      let startDateAdditionDataID: any = startDateID[programName]
      let date = additionalData[startDateAdditionDataID]

      startDate = moment.utc(date)
      endDate = moment.utc(date).add(60, 'days')
    }

    CareCoordinationService.createNewProgram({
      patientId: patientId,
      programId: selectedValuesOfProgram,
      programName: programName,
      startDate,
      endDate: programName === "HIC" ? moment.utc("9999-12-31", "YYYY-MM-DD") : endDate,
    }).subscribe({
      next: (v) => {
        const response = v.data.data;
        if (milleniumClientCheck()) {
          updateAssignedStatus(selectedValuesOfProgram, response.patientPrgmId);
        }
        if (actionData.action === CREATE_CARE_PRGM && actionData.updateCallBack) {
          actionData.updateCallBack();
          const assignedPrgmsCopy = cloneDeep(assignedPrograms);
          const selectedIndex = findIndex(assignedPrgmsCopy, { id: selectedValuesOfProgram });
          if (selectedIndex !== -1) {
            set(assignedPrgmsCopy[selectedIndex], "status", "Active");
            set(assignedPrgmsCopy[selectedIndex], "patientProgramId", response.patientPrgmId);
          }
          setAssignedPrograms(assignedPrgmsCopy);
          setProgramLoading(false);
        } else {
          initialLoad({ programId: selectedValuesOfProgram, patientProgramId: response.patientPrgmId , callback : updateAdditionalDataInTask});
        }
        updatePatientCaseStatus(patientId, programDescription);
        setLoading(false);
        setIsModalVisible(false);

        // updating registry dependent programs
        setRegistryDependentProgramsStatus([...registryDependentProgramsStatus, programName]);
      },
      error: (e) => {
        console.log(e);
        setIsModalVisible(false);
        setLoading(false);
        setProgramLoading(false);
      },
    });
    const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
      USER_ACTION_DESCRIPTION_PROGRAM_ASSIGNMENT,
      CASE_STATUS_REASON_ASSIGNMENT,
      true
    );
    membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
      next: (v) => {
        console.log("updated status successfully");
      },
      error: (e) => {
        console.log("update status failed");
      },
    });
  }

  const addNewProgram = () => {
    if (!selectedValuesOfProgram) {
      notification.error({
        message: "Error",
        description: "Please choose Program",
      });
    } else if ((programName === "HIC" ? !interventionStartDate : !interventionStartDate || !programEndDate) && noAdditionalData) {
      notification.error({
        message: "Error",
        description: `Please enter ${programName === "HIC" ? "program start date." : "Proper Date range."}`,
      });
    } else {
      if (additionalDetails.length > 0) {
        setIsModalVisible(false);
        setAdditionalDetailsVisible(true);
      } else {
        createNewProgramServiceCall(selectedValuesOfProgram);
      }
    }
  };

  const updatePatientCaseStatus = (patientId: any, programDescription: any) => {
    let forceStatus = undefined
    if (milleniumClientCheck()) {
      let selectedProgram = assignedPrograms.find((i: any) => i.id === selectedValuesOfProgram)

      if (selectedProgram?.prgmMetadata?.isCaseStatusAutomation === true) {
        forceStatus = CASE_STATUS_ACTIVE
      }
    }
    
    if (membersService.getCurrentMember.patient_case_status !== CASE_STATUS_CLOSED) {
      setMemberPageLoader(true);
      membersService
        .updateStatus(
          patientId,
          CASE_STATUS_REASON_PROGRAM_CHANGE,
          USER_ACTION_MODULE_MEMBER_DETAIL,
          USER_ACTION_TAB_CARE_MANAGEMENT,
          `${programDescription}$|${USER_ACTION_CARD_PROGRAM}`,
          `${programDescription}$|${USER_ACTION_LOCATION_PROGRAM}`,
          USER_ACTION_DESCRIPTION_PROGRAM_SAVE,
          isAutoCaseStatus(forceStatus)
        )
        .subscribe({
          next: (res) => {
            let currentMember = { ...membersService.getCurrentMember };
            currentMember.case_last_action_date = res?.data?.data?.caseLastActionDate;
            currentMember.patient_case_status = res?.data?.data?.caseStatus;

            const filteredLinkedProgramList = getFilteredLinkedProgramList();
            if (filteredLinkedProgramList && filteredLinkedProgramList?.length > 0 && currentMember?.[filteredLinkedProgramList?.[0]?.value] === "N") {
              currentMember[filteredLinkedProgramList?.[0]?.value] = "Y";
            }
            membersService.setCurrentMember = currentMember;
            let tempMemberList = [...membersService.getMemberList];
            tempMemberList = tempMemberList?.map((item: any) => {
              let mem = cloneDeep(item);
              if (currentMember?.patient_id === mem?.patient_id) {
                mem = {
                  ...mem,
                  ...currentMember,
                };
              }
              return mem;
            });
            membersService.setMemberList = tempMemberList;
            setMemberPageLoader(false);
          },
          error: (error: any) => setMemberPageLoader(false),
        });
    }
  };

  const modalTitle = () => {
    return !registryDependentProgramModalVisibility ? (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>Add Program</div>
        {(!noDataFlag && noAdditionalData) ? (
          <div className="ui-care-coordination__programs__datePicker">
            <Icon name="calender" />
            {programName === "HIC" ? (
              <DatePicker
                key={interventionStartDate?.toString()}
                value={!isEmpty(interventionStartDate) ? moment(interventionStartDate) : null}
                disabledDate={disabledDate}
                format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                onChange={(date: any) => {
                  setInterventionStartDate(moment(date));
                }}
              />
            ) : (
              <RangePicker
                key={interventionStartDate?.toString()}
                value={[!isEmpty(interventionStartDate) ? moment(interventionStartDate) : null, !isEmpty(programEndDate) ? moment(programEndDate) : null]}
                onChange={(range) => {
                  if (range) {
                    setInterventionStartDate(moment(range[0]));
                    setProgramEndDate(moment(range[1]));
                  }
                }}
                disabledDate={disabledDate}
                format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
              />
            )}
          </div>
        ) : null}
      </div>
    ) : null;
  };

  const updateRegistry = (updateFlag: boolean = false) => {
    if (updateFlag) {
      setLoading(true);
      setRegistryDependentProgramModalVisibility(false);
      const filteredLinkedProgramList = getFilteredLinkedProgramList();
      if (filteredLinkedProgramList && filteredLinkedProgramList?.length > 0) {
        memberService.classificationUpdate(patientId, true, filteredLinkedProgramList?.[0]?.classification).subscribe({
          next: (res: any) => {
            setMemberDetailClassificationValues({
              ...memberDetailClassificationValues,
              [filteredLinkedProgramList?.[0]?.classification]: "Y",
            });
            membersService
              .updateStatus(
                patientId,
                CASE_STATUS_REASON_PROGRAM_CHANGE,
                USER_ACTION_MODULE_MEMBER_DETAIL,
                USER_ACTION_TAB_CARE_MANAGEMENT,
                `${programDescription}$|${patientProgramId}$|${USER_ACTION_CARD_PROGRAM}`,
                `${programDescription}$|${USER_ACTION_LOCATION_PROGRAM}`,
                USER_ACTION_DESCRIPTION_REGISTRY_UPDATE,
                isAutoCaseStatus()
              )
              .subscribe({
                next: (res) => {
                  addNewProgram();
                },
              });
          },
          error: (error: any) => {
            console.log(error);
            setLoading(false);
          },
        });
      }
    } else {
      setRegistryDependentProgramModalVisibility(false);
    }
  };

  const getFilteredLinkedProgramList = () => {
    return memberDetailListRegistryDropDown?.filter((item: any) => {
      if (item?.optionalValue?.registryLinkedProgram) {
        const programToBeFound = find(item.optionalValue?.registryLinkedProgram, { careProgramConfiguredProgramName: programName });
        if (programToBeFound) {
          return true;
        }
      }
      return false;
    });
  };

  const  handleAdditionDetailsCancel = () => {
    setAdditionalDetailsVisible(false);
    setAdditionalData({});
  }

  const handleAdditionalDetailsOk = () => {
      setAdditionalDetailsVisible(false);
      createNewProgramServiceCall(selectedValuesOfProgram);
  }

  const handlePopUpCancel = () => {
    if (actionData?.cancelCallBack) {
      actionData?.cancelCallBack();
    }
    setRegistryDependentProgramModalVisibility(false);
    setIsModalVisible(false);
  };

  const handlePopUpOk = () => {
    const filteredLinkedProgramList = getFilteredLinkedProgramList();
    if (
      filteredLinkedProgramList?.length > 0 &&
      (memberDetailClassificationValues[filteredLinkedProgramList?.[0]?.classification] === "N" ||
        !memberDetailClassificationValues.hasOwnProperty(filteredLinkedProgramList?.[0]?.classification))
    ) {
      setRegistryDependentProgramModalVisibility(true);
    } else addNewProgram();
  }

  return (
    <div className="ui-care-coordination__programs">
      <Modal
        className={`ui-care-coordination__programs ${!registryDependentProgramModalVisibility ? "" : "hideDefaultFooterOfModal"}`}
        title={modalTitle()}
        open={isModalVisible}
        onCancel={handlePopUpCancel}
        onOk={handlePopUpOk}
        // okText={"Save"}
        // okButtonProps={{ disabled: noDataFlag }}
        closable={false}
        confirmLoading={loading}
        footer={
          [
            <div className="ui-care-coordination__programs-seperator"></div>,
            <div className={`ui-care-coordination__programs__static-message`}>Non selectable programs are either declined or have no eligible users assigned to them within the referral section.</div>,
            <div className="ui-care-coordination__programs-seperator"></div>,
            <Button key="back" onClick={handlePopUpCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handlePopUpOk}  disabled={noDataFlag}>
              Save
            </Button>,
          ]
        }
      >
        {!noDataFlag && !registryDependentProgramModalVisibility ? (
          <>
            {actionData.action !== CREATE_CARE_PRGM ? (
              <Input
                className="ui-care-coordination__programs__search"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                placeholder="Search"
                suffix={<Icon name="search" />}
              />
            ) : (
              false
            )}
            <Radio.Group
              value={selectedValuesOfProgram}
              className="ui-care-coordination__programs__options custom-scroll-bar"
              style={{ minHeight: modifedProgramSize + "px" }}
              onChange={({ target: { value } }) => handleSelectingProgram(value)}
            >
              {map(
                filter(modPrograms, (program: any) => {
                  return includes(program?.name?.toLowerCase(), searchValue?.toLowerCase());
                }),
                (program) => {

                  const {id , name , description , isDeclined , declinedBy , declinedAt} = program;

                  const optionClassName = classnames("ui-care-coordination__programs__options__option", {
                    "ui-care-coordination__programs__options__option--selected": selectedValuesOfProgram === id,
                  });

                  return (
                    // user should not be able to add TCM Program Manually from UI
                    // process.env.REACT_APP_TCM_ENABLED === "false"
                    // For myCare manual tcm program creation is disabled as per requirement in release 1.3.1
                    name === "TCM" && getClientName() === "Mycare" ? null : description === "PALLIATIVE CARE" &&
                      isEmpty(get(find(get(reerralStore, "referrals.editable", {}), { role_name: "Palliative Care Worker" }), "assigne_id", "")) ? (
                      <Radio.Button className={optionClassName} key={id} value={id} disabled={true}>
                        <Spinner
                          tooltip={isDeclined ? `Decline Record by ${declinedBy} on ${moment(declinedAt).format("MM-DD-YYYY")}` : `Please assign a Palliative Care Worker to enable this program`}
                        >
                          {description}
                        </Spinner>
                      </Radio.Button>
                    ) : (
                      <Radio.Button className={optionClassName} key={id} value={id} disabled={isDeclined || (actionData.action === CREATE_CARE_PRGM ? !(selectedValuesOfProgram === id) : false)}>
                        <Spinner tooltip={isDeclined ? `Decline Record by ${declinedBy} on ${moment(declinedAt).format("MM-DD-YYYY")}` : ""}>{description}</Spinner>
                      </Radio.Button>
                    )
                  );
                }
              )}
            </Radio.Group>
          </>
        ) : registryDependentProgramModalVisibility ? (
          <div className="registryLinkedProgram_confirmation">
            <div className="registryLinkedProgram_confirmation__header">
              <div className="registryLinkedProgram_confirmation__header__title">Create Program</div>
              <div className="registryLinkedProgram_confirmation__header__message">Update {programDescription} registry and create the program.</div>
            </div>
            <div className="registryLinkedProgram_confirmation__footer">
              <div className="registryLinkedProgram_confirmation__footer__cancel">
                <Button onClick={() => updateRegistry(false)}>Cancel</Button>
              </div>
              <div className="registryLinkedProgram_confirmation__footer__ok">
                <Button type="primary" onClick={() => updateRegistry(true)}>
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <DataNotFound message={NO_PROGRAM_AVAILABLE}/>
        )}
      </Modal>
      <GenericModal
        title={`${programName} - Additional Details`}
        open={additionalDetailsVisible}
        handleOk={handleAdditionalDetailsOk}
        handleCancel={handleAdditionDetailsCancel}
        okText={"Create"}
        width={"38rem"}
        okButtonProps={{ disabled: !isAdditionalValidationSuccess()}}
      >
        <p className="additional_details__message">Please select the following program related details to proceed:</p>
        <div className="additional_details__body">
          {additionalDetails.map((a : any) => {
            return <CustomDatePicker
            value={a.validation ? (!a.validation(additionalData[a.subtaskTempId]) ? additionalData[a.subtaskTempId] : undefined) : additionalData[a.subtaskTempId]}
            label={a.label}
            onChange={(date: any) => setAdditionalData({ ...additionalData, [a.subtaskTempId] : date.startOf('minute') })}
            disabledDate={a.validation}
            disabled = {disableInput(a)}
          />
          })}
        </div>
      </GenericModal>
    </div>
  );
};

export default Program;
